import './App.css';
import HomeScreen from './components/MainScreens/HomeScreen';
import AdminLogin from "./components/AuthScreens/AdminLogin"
import { Route,Routes} from 'react-router-dom'  
import React, { useEffect, useState } from 'react';
import {app} from "./firebase"
import { getAuth} from "firebase/auth";
import AdminPanel from './components/AuthScreens/AdminPanel';

function App() {
  const [initializing, setInitializing] = useState(true);
  const [user, setUser] = useState();
  const auth = getAuth(app);

  function onAuthStateChanged(user){
    setUser(user);
    if(initializing) setInitializing(false);
  }

  useEffect(()=>{
    const subscriber = auth.onAuthStateChanged(onAuthStateChanged);
    return subscriber
  },[]);

  if(user){
    return (
     <>
       <AdminPanel />
     </>
    );
  }
  return (
     <> 
      <Routes>
          <Route exact path="/" element={<HomeScreen />}/>
          <Route path="/Admin" element={<AdminLogin/> }/>
          <Route path="/Admin" element={<AdminLogin/> }/>
      </Routes>
    
    </>
  );
}

export default App